const STORE_KEY = 'USER'

export const SET_EMAIL = `${STORE_KEY}/SET_EMAIL`
